export default __webpack_public_path__ + "static/media/peach1.4328ebc6.png";